<section class="ach">
  <div class="ach-head">
    <strong>Chat history</strong>
    <button type="button" class="ach-toggle" aria-haspopup="dialog" (click)="show.emit()">Show</button>
  </div>
  <p class="ach-muted">Resume earlier conversations with {{ agentName || 'your agent' }}.</p>
</section>
